import { Instance } from 'mobx-state-tree'
import { now } from 'mobx-utils'
import dayjs from 'dayjs'
import ObjectId from 'bson-objectid'
import { MessageResponseModelBase } from './MessageResponseModel.base'

/* The TypeScript type of an instance of MessageResponseModel */
export interface MessageResponseModelType
  extends Instance<typeof MessageResponseModel.Type> {}

/* A graphql query fragment builders for MessageResponseModel */
export {
  selectFromMessageResponse,
  messageResponseModelPrimitives,
  MessageResponseModelSelector
} from './MessageResponseModel.base'

/**
 * MessageResponseModel
 */
export const MessageResponseModel = MessageResponseModelBase.views(self => ({
  get $timestamp() {
    if (self._id === undefined) return new ObjectId().getTimestamp()
    return new ObjectId(self._id).getTimestamp()
  }
}))
  .views(self => ({
    get timeSignature() {
      const messagePostedThisYear =
        dayjs(self.$timestamp).year() !== dayjs(now(60000)).year()

      const messagePostedYesterdayOrToday = dayjs(now(60000))
        .subtract(1, 'day')
        .startOf('day')
        .isAfter(self.$timestamp)

      if (messagePostedThisYear)
        return dayjs(self.$timestamp).format('MMM D, YYYY, HH:mm')

      if (messagePostedYesterdayOrToday)
        return dayjs(self.$timestamp).format('MMM D, HH:mm')

      return dayjs(self.$timestamp).format('HH:mm')
    }
  }))
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    }
  }))
